import posthog from "posthog-js";
import { getSeparatedOptionsStringified } from "./index";
import { OrderType } from "./constants";

const NOMENCLATURE_EVENTS = {
  NO_RESULTS: "homologar:nomenclature_search_end",
  NO_SELECTED_OPTION: "homologar:nomenclature_search_fail",
  SELECTED_OPTION: "homologar:nomenclature_search_click",
  FULL_INPUT_DELETE: "homologar:nomenclature_search_cancel",
};

function captureEvent(eventName, data) {
  posthog.capture(eventName, data);
}

class NoneEventsHandler {
  orderType;

  constructor(orderType) {
    this.orderType = orderType;
  }

  onSelectedOption(_value, _inputValue, _options) {}

  onFullInputDelete(_previousInputValue, _options) {}

  onNoResults(_query) {}

  handleNoSelectedOptionOrders(_orders) {}
}

class NomenclatureEventsHandler {
  orderType;
  appVersion;

  constructor(orderType, appVersion) {
    this.orderType = orderType;
    this.appVersion = appVersion;
  }

  onSelectedOption(value, inputValue, options) {
    captureEvent(NOMENCLATURE_EVENTS.SELECTED_OPTION, {
      selected: value,
      input_value: inputValue,
      procedure_type: value?.procedureType ?? this.orderType,
      app_version: this.appVersion,
      ...getSeparatedOptionsStringified(options),
    });
  }

  onFullInputDelete(previousInputValue, options) {
    captureEvent(NOMENCLATURE_EVENTS.FULL_INPUT_DELETE, {
      previous_input: previousInputValue,
      procedure_type: this.orderType,
      app_version: this.appVersion,
      ...getSeparatedOptionsStringified(options),
    });
  }

  onNoResults(query) {
    captureEvent(NOMENCLATURE_EVENTS.NO_RESULTS, {
      query,
      procedure_type: this.orderType,
      app_version: this.appVersion,
    });
  }

  onNoSelectedOption(order) {
    const clarifications = order.clarifications.split("\n").filter(Boolean);
    if (clarifications.length > 0) {
      clarifications.forEach((clarification) => {
        captureEvent(NOMENCLATURE_EVENTS.NO_SELECTED_OPTION, {
          actual_order: clarification,
          procedure_type: order.procedureType ?? this.orderType,
          app_version: this.appVersion,
        });
      });
    }
  }

  handleNoSelectedOptionOrders(orders) {
    const ordersWithNoSelectedOption = orders.filter(
      (order) => order.items.length === 0
    );

    if (ordersWithNoSelectedOption.length > 0) {
      ordersWithNoSelectedOption.forEach((order) =>
        this.onNoSelectedOption(order)
      );
    }
  }
}

const eventHandlerMapper = {
  [OrderType.MANUAL]: (_appVersion) => new NoneEventsHandler(OrderType.MANUAL),
  [OrderType.IMAGING]: (appVersion) => new NomenclatureEventsHandler(OrderType.IMAGING, appVersion),
  [OrderType.LABORATORY]: (appVersion) =>
    new NomenclatureEventsHandler(OrderType.LABORATORY, appVersion),
  [OrderType.PRACTICES]: (appVersion) =>
    new NomenclatureEventsHandler(OrderType.PRACTICES, appVersion),
};

export const getEventNomenclatureEventHandler = (orderType, appVersion) => {
  const factory = eventHandlerMapper[orderType] ?? eventHandlerMapper[OrderType.IMAGING];
  return factory(appVersion);
};
